import React from 'react';
import PropTypes from 'prop-types';

import Markdown from '../Markdown';

const FieldsetDescriptionRenderer = ({ item }) => {
  const reactMarkdownClassName =
    item.fieldsetDescription === null || item.fieldsetDescription === ''
      ? 'mb-5'
      : 'mt-xl-5';

  return (
    <Markdown
      className={`col-xl-12 col-lg-12 ${reactMarkdownClassName} card-header`}
      text={item.fieldsetDescription}
    />
  );
};

FieldsetDescriptionRenderer.propTypes = {
  item: PropTypes.object.isRequired,
};

export default FieldsetDescriptionRenderer;
